<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { ref } from 'vue';
import { TEXT } from '../../configs/text';
import { useClassStore } from '../../stores';
import Button from '../General/Button.vue';
import Modal from '../General/Modal.vue';
import Heading from '../General/Heading.vue';
import SetGroup from '../Class/SetGroup.vue';

const classStore = useClassStore()
const modalShow = ref<boolean>(false)

function handleRequest() {
    modalShow.value = true
}

const { t } = useI18n()
</script>

<template>
    <Button @click="handleRequest" color="main" type="outline" class="group">
        <span>{{ t(TEXT.request) }}</span>
        <span class="size-6 rounded-full flex items-center justify-center leading-none bg-orange-600  text-white ">
            {{ classStore.requestedStudentIds.length }}
        </span>
    </Button>
    <Modal v-model="modalShow" size="large">
        <Heading alignment="center">{{ t(TEXT.student_request) }}</Heading>
        <SetGroup :student-ids="classStore.requestedStudentIds" :approve="true" @update="modalShow = false" />
    </Modal>
</template>